/**
 * View mode - Toggle class between Primary & Secondary (On model & Product only)
 * The Product cards are changed with the group tailwind class.
 * Preference is stored in cart.attributes.product_overview_view for server-side rendering.
 */
if (!customElements.get('product-card-view')) {
  class ProductCardView extends HTMLElement {
    connectedCallback() {
      this.mainCardOverview = this.closest('[data-main-collection]');
      this.viewPrimary = this.querySelector('[data-view-primary]');
      this.viewSecondary = this.querySelector('[data-view-secondary]');

      // Change the view to Secondary, if that was the last selected view
      const isSecondary = this.mainCardOverview?.classList.contains('product-card-view--secondary');
      this.syncRadioFromState(this.viewPrimary, !isSecondary);
      this.syncRadioFromState(this.viewSecondary, isSecondary);

      // Get the click on the view options
      [this.viewPrimary, this.viewSecondary].forEach((input) => {
        input.addEventListener('change', (event) => this.switchView(event.currentTarget));
      });
    }

    switchView(input) {
      const isSecondary = input === this.viewSecondary;
      this.toggleSecondaryView(isSecondary);
      this.updateCartAttribute(isSecondary ? 'secondary' : 'primary');
    }

    toggleSecondaryView(isSecondary = true) {
      this.mainCardOverview?.classList.toggle('product-card-view--secondary', isSecondary);

      this.syncRadioFromState(this.viewPrimary, !isSecondary);
      this.syncRadioFromState(this.viewSecondary, isSecondary);
    }

    syncRadioFromState(el, isActive) {
      el.checked = isActive;
    }

    async updateCartAttribute(view) {
      try {
        await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          ...fetchConfig(),
          body: JSON.stringify({
            attributes: {
              product_overview_view: view,
            },
          }),
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
  customElements.define('product-card-view', ProductCardView);
}
